import React from 'react';
import { Card, CardContent } from '@/components/ui';

export function AdminQuickActions() {
  const actions = [
    { label: 'Thêm người dùng', icon: 'ri-user-add-line', color: 'text-blue-500', bg: 'bg-blue-50' },
    { label: 'Thêm vai trò', icon: 'ri-shield-keyhole-line', color: 'text-purple-500', bg: 'bg-purple-50' },
    { label: 'Sao lưu ngay', icon: 'ri-database-2-line', color: 'text-emerald-500', bg: 'bg-emerald-50' },
    { label: 'Cài đặt hệ thống', icon: 'ri-settings-4-line', color: 'text-orange-500', bg: 'bg-orange-50' },
    { label: 'Xem nhật ký', icon: 'ri-file-list-3-line', color: 'text-blue-500', bg: 'bg-blue-50' },
    { label: 'Quản lý dữ liệu', icon: 'ri-key-2-line', color: 'text-purple-500', bg: 'bg-purple-50' },
  ];

  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <h3 className="text-sm font-bold text-slate-800 mb-6">Thao tác nhanh</h3>
        
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
          {actions.map((action) => (
            <button 
              key={action.label} 
              className="flex flex-col items-center justify-center gap-2 p-4 rounded-xl border border-slate-50 hover:border-blue-100 hover:bg-blue-50/30 transition-all group"
            >
              <div className={`w-10 h-10 rounded-xl ${action.bg} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                <i className={`${action.icon} ${action.color} text-xl`} />
              </div>
              <span className="text-[10px] font-bold text-slate-600 text-center leading-tight">
                {action.label}
              </span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
